// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getProduct, addSegmentToProduct, removeSegmentFromProduct, updateProduct } from '../../../state/actions/ProductActions';
import { getSegments, removeProductFromSegment, addProductToSegment } from '../../../state/actions/SegmentActions';
import { getProductCategory, getProductType } from '../../../state/actions/CategoryActions';
import { SegmentSection } from '../../Equipment/Details/SegmentSection';
import { ProductInfoSection } from './ProductInfoSection';
import { Loading} from '../../../containers/Loading';
import { AddSegmentToItemModal } from '../../../modals/AddSegmentToItemModal';
import { ImageSection } from '../../../containers/ImageSection';
import { ProductSpecsModal } from '../../../modals/ProductSpecsModal';

// COMPONENT
class ProductDetailsPage extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            product: {},
            productName: '',
            segments: [],
            type: {},
            category: {},
            subcategory: {},
            packSizeString: '',
            segmentModal: false,
            previewImage: '',
            specsModal: false
        };

        this.updateSegments = this.updateSegments.bind(this);
        this.removeSegment = this.removeSegment.bind(this);
        this.updateDependancies = this.updateDependancies.bind(this);
        this.toggleSegmentModal = this.toggleSegmentModal.bind(this);
        this.addSegment = this.addSegment.bind(this);
        this.updateType = this.updateType.bind(this);
        this.updateCategory = this.updateCategory.bind(this);
        this.constructPackSizeString = this.constructPackSizeString.bind(this);
        this.round = this.round.bind(this);
        this.updateProduct = this.updateProduct.bind(this);
        this.toggleSpecsModal = this.toggleSpecsModal.bind(this);
    }

    componentDidMount(){
        this.props.getProduct(this.props.match.params.productId);
    }

    updateProduct(product){
        this.props.updateProduct(product);
    }

    updateDependancies(){
        if(this.props.product != {} && this.props.product != null) {
            this.updateSegments();
            this.updateType();
            this.updateCategory();
        }
    }

    updateSegments(){
        if(this.props.product.segments != null && this.props.product.segments != undefined) {
            this.props.getSegments(Object.keys(this.props.product.segments));
        }
    }

    updateType(){
        if(this.props.product.type != undefined){
            this.props.getProductType(this.props.product.type);
        }
    }

    updateCategory(){
        if(this.props.product.category != undefined){
            this.props.getProductCategory(this.props.product.category);
        }
    }

    componentDidUpdate(prevProps) {
        if(JSON.stringify(this.props.product) != JSON.stringify(prevProps.product)) {
            this.setState({
                product: this.props.product,
                previewImage: this.props.product['preview-image']
            });

            if(this.props.product != undefined && this.props.product != null){
                this.setState({
                    productName: this.props.product.name,
                });
                this.updateDependancies();
                this.constructPackSizeString();
            }
        }

        if(this.props.segments != prevProps.segments){
            this.setState({segments: this.props.segments});
        }

        if(this.props.addedProductToSegment == true && prevProps.addedProductToSegment == false){
            this.props.getProduct(this.props.match.params.productId);
        }

        if(this.props.productCategory != prevProps.productCategory){
            this.setState({
                category: this.props.productCategory,
                subcategory: this.props.productCategory.subcategories[this.props.product.subcategory]
            });
        }

        if(this.props.productType != prevProps.productType){
            this.setState({type: this.props.productType});
        }
    }

    constructPackSizeString(){
        if(this.props.product.size != undefined) {
            let size = this.props.product.size;
            let unit = this.props.product.unit;
            if(size >= 1000) {
                size = size / 1000;
                size = Math.round(size * 100) / 100; 
                if (unit == 'ml') {
                    unit = 'lt';
                } else if (unit == 'g') {
                    unit = 'kg';
                }
            }
            this.setState({packSizeString: size.toString() + unit});
        } else {
            this.setState({packSizeString: 'unknown'});
        }
    }

    round(num, precision = 2) {
        var scaled = Math.round(num + 'e' + precision);
        return Number(scaled + 'e' + -precision);
    }

    toggleSegmentModal() {
        this.setState({
            segmentModal: !this.state.segmentModal
        });
    }

    toggleSpecsModal() {
        this.setState({
            specsModal: !this.state.specsModal
        });
    }

    addSegment(segmentID){
        this.props.addSegmentToProduct(segmentID, [this.props.match.params.productId]);
        this.props.addProductToSegment(segmentID, [this.props.match.params.productId]);

        this.updateSegments();
    }

    removeSegment(segmentId){
        this.props.removeProductFromSegment(segmentId, this.props.product.id);
        this.props.removeSegmentFromProduct(segmentId, this.props.product.id);
    }

    render() {
        return (
            <Fragment>
                <div className="page-title">Product: {this.state.productName}</div>

                {(this.props.fetchingProduct || this.props.fetchingSegments) &&
                    <Loading/>
                }

                {!this.props.fetchingSegments && !this.props.fetchingProduct && this.state.product != {} && 
                    <div>
                        <ImageSection imageName={this.state.previewImage} storageLocation={'preview-images'} width={300} height={150}/>
                        <ProductInfoSection category={this.state.category} subcategory={this.state.subcategory} type={this.state.type} packSize={this.state.packSizeString} toggleModal={this.toggleSpecsModal}/>
                        <SegmentSection subtitle={''} emptyText={'There are no segments associated with this product'} deleteItem={this.removeSegment} segments={this.state.segments} toggleModal={this.toggleSegmentModal}/>
                    </div>
                }

                {true && <AddSegmentToItemModal isOpen={this.state.segmentModal} toggleModal={this.toggleSegmentModal} addSegment={this.addSegment} assignedSegments={this.state.segments}/>}
                {true && <ProductSpecsModal isOpen={this.state.specsModal} toggleModal={this.toggleSpecsModal} product={this.state.product} updateProduct={this.updateProduct}/>}

            </Fragment>
        );
    }
}

ProductDetailsPage.propTypes = {
    getProduct: PropTypes.func.isRequired,
    getSegments: PropTypes.func.isRequired,
    removeSegmentFromProduct: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    product: PropTypes.object.isRequired,
    segments: PropTypes.array.isRequired,
    fetchingProduct: PropTypes.bool.isRequired,
    fetchedProduct: PropTypes.bool.isRequired,
    failedProduct: PropTypes.bool.isRequired,
    match: PropTypes.object.isRequired,
    fetchingSegments: PropTypes.bool.isRequired,
    fetchedSegments: PropTypes.bool.isRequired,
    failedSegments: PropTypes.bool.isRequired,
    addSegmentToProduct: PropTypes.func.isRequired,
    addedProductToSegment: PropTypes.bool.isRequired,
    addingProductToSegment: PropTypes.bool.isRequired,
    addedSegmentToProduct: PropTypes.bool.isRequired,
    addingSegmentToProduct: PropTypes.bool.isRequired,
    removeProductFromSegment: PropTypes.func.isRequired,
    addProductToSegment: PropTypes.func.isRequired,
    productCategory: PropTypes.object.isRequired,
    productType: PropTypes.object.isRequired, 
    fetchingProductType: PropTypes.bool.isRequired, 
    fetchedProductType: PropTypes.bool.isRequired,
    failedProductType: PropTypes.bool.isRequired,
    fetchingProductCategory: PropTypes.bool.isRequired,
    fetchedProductCategory: PropTypes.bool.isRequired,
    failedProductCategory: PropTypes.bool.isRequired,
    getProductType: PropTypes.func.isRequired,
    getProductCategory: PropTypes.func.isRequired,
    updateProduct: PropTypes.func.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { product, fetchingProduct, fetchedProduct, failedProduct, addingSegmentToProduct, addedSegmentToProduct } = state.productReducer;
    const { segments, fetchingSegments, fetchedSegments, failedSegments, addingProductToSegment, addedProductToSegment } = state.segmentReducer;
    const { productCategory, productType, fetchingProductType, fetchedProductType, failedProductType, fetchingProductCategory, fetchedProductCategory, failedProductCategory } = state.categoryReducer;
    return { product, segments, fetchingProduct, fetchedProduct, failedProduct, fetchingSegments, fetchedSegments, failedSegments,  addingProductToSegment, addedProductToSegment, addingSegmentToProduct, addedSegmentToProduct,
        productCategory, productType, fetchingProductType, fetchedProductType, failedProductType, fetchingProductCategory, fetchedProductCategory, failedProductCategory };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ getProduct, getSegments, removeSegmentFromProduct, addSegmentToProduct, removeProductFromSegment, addProductToSegment, getProductType, getProductCategory, updateProduct }, dispatch)
);

// CONFIGURE REACT REDUX

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsPage));

// EXPORT COMPONENT

export { hoc as ProductDetailsPage };


// WEBPACK FOOTER //
// ./src/components/pages/Products/Details/ProductDetailsPage.js